//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import linkaddressVue from '@/components/linkaddress';
import Card from '../../../components/Card';
import { deepCopy } from '@/utils';
import mixin from '../../formMixin';
import dragEffect from '../../../components/js/draggableEffect';
import { swapElement } from '../../../components/js/common';
export default {
  name: 'NavListForm',
  mixins: [mixin, dragEffect],
  components: {
    linkaddressVue: linkaddressVue,
    Card: Card
  },
  data: function data() {
    return {
      initData: {
        url: '',
        pic: '',
        name: ''
      },
      form: {
        showType: 2,
        menus: [{}],
        navPadding: {
          pt: 0,
          pb: 0,
          pl: 15,
          pr: 15
        }
      },
      itemIndex: null
    };
  },
  watch: {
    propsData: {
      handler: function handler(propsData) {
        var _this$form;
        this.form = Object.assign(this.form, propsData);
        if (!((_this$form = this.form) !== null && _this$form !== void 0 && _this$form.navPadding)) {
          this.$set(this.form, 'navPadding', {
            pt: 0,
            pb: 0,
            pl: 15,
            pr: 15
          });
        }
        ;
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    swapElement: swapElement,
    linkUrl: function linkUrl(url) {
      this.form.menus[this.itemIndex].url = url;
    },
    openLink: function openLink(index) {
      this.itemIndex = index;
      this.$refs.linkaddressVueRef.dialogVisible = true;
    },
    upload: function upload(index) {
      var _this = this;
      this.$modalUpload(function () {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        _this.$set(_this.form.menus[index], 'pic', data[0].sattDir);
      });
    },
    handleRemove: function handleRemove(index) {
      this.form.menus.splice(index, 1);
    },
    addContent: function addContent() {
      this.form.menus.push(deepCopy(this.initData));
    },
    handleDragenter: function handleDragenter(index) {
      this.dragging = index;
      var currentIndex = index;
      var dragStartIndex = this.dragStartIndex;
      if (currentIndex !== dragStartIndex) {
        this.form.menus = this.swapElement(this.form.menus, currentIndex, dragStartIndex);
        this.dragStartIndex = currentIndex;
      }
    }
  }
};